import { render, staticRenderFns } from "./game_profiles.vue?vue&type=template&id=f40a8fce"
import script from "./game_profiles.vue?vue&type=script&lang=js"
export * from "./game_profiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports